/**
 * Time formatting utilities for player components
 */

/**
 * Format seconds as MM:SS or H:MM:SS for display
 *
 * @param sec - Time in seconds
 * @returns Formatted time string
 *
 * @example
 * formatTime(65) // "1:05"
 * formatTime(3665) // "1:01:05"
 */
export function formatTime(sec: number): string {
  const s = Math.max(0, Math.floor(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;

  if (h > 0) {
    return `${h}:${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
  }

  return `${m}:${String(r).padStart(2, "0")}`;
}
